<template>
  <div v-if="modelValue === undefined">
    <div class="product-container">
      <p class="notification-subtitle paddingBottom no-margin">Choose Bots</p>
      <div class="selectProductSearch">
        <VTextField
          v-model="botFilter"
          placeholder="Search Bots"
          aria-label="choose bots"
          appearance="ghost"
          class="vivid-input"
          icon="search-line"
        ></VTextField>
      </div>
      <div v-if="botsToShow.length > 0" class="productListItems">
        <div class="bot-list">
          <div
            v-for="(thisBot, index) in botsToShow"
            :key="`bot-${index}-${thisBot.id}`"
            class="bot-item"
            @click="emit('update:modelValue', thisBot.id)"
          >
            <div class="productDesc">
              <p class="title no-margin">{{ thisBot.displayname }}</p>
            </div>
            <span class="radio-indicator" :class="{ checked: modelValue === thisBot.id }"></span>
          </div>
        </div>
      </div>
      <div v-else class="text-center info-message">
        <img src="@/resources/images/empty_box.svg" class="emptyProducts" alt="empty_bots" />
        <h5>No Bots found!</h5>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="selected-bot-card">
      <div class="bot-info">
        <h2 class="title custPadding">{{ allBots.find(bot => bot?.id === modelValue)?.displayname }}</h2>
      </div>
      <VIcon name="delete-line" connotation="alert" class="trashIcon cursorPointer" @click="onClear"></VIcon>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';

export interface Bot {
  id: string
  displayname: string
  active?: boolean
}

const props = defineProps<{
  modelValue: string | undefined
  allBots: Bot[]
}>();

const emit = defineEmits<{
  'update:modelValue': [value: string | undefined]
  'clear': []
}>();

const botFilter = ref('');

const botsToShow = computed(() => {
  if (!Array.isArray(props.allBots) || props.allBots.length === 0) return [];
  if (!botFilter.value?.trim()) return props.allBots;
  const searchTerm = botFilter.value.trim().toLowerCase();
  return props.allBots.filter(bot => bot?.displayname?.toLowerCase().includes(searchTerm));
});

function onClear() {
  botFilter.value = '';
  emit('update:modelValue', undefined);
  emit('clear');
}
</script>

<style scoped>
.product-container {
  margin-top: 20px;
  margin-bottom: 20px;
}
.selectProductSearch {
  margin-bottom: 10px;
}
.bot-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.bot-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: var(--background-primary);
  border-radius: 5px;
  padding: 12px 16px;
  cursor: pointer;
  min-height: 50px;
}
.bot-item:hover {
  background: var(--purple-opac);
}
.productListItems {
  overflow-y: auto;
  max-height: 62vh;
}
.productDesc {
  flex: 1;
}
.radio-indicator {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid var(--gray-04);
  flex-shrink: 0;
  position: relative;
}
.radio-indicator.checked {
  border-color: var(--purple);
}
.radio-indicator.checked::after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--purple);
}
.selected-bot-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: var(--background-primary);
  border-radius: 5px;
  padding: 12px 16px;
  margin-top: 20px;
}
.bot-info {
  flex: 1;
}
.no-margin {
  margin: 0;
}
.paddingBottom {
  padding-bottom: 10px;
}
.custPadding {
  padding-bottom: 5px;
}
</style>
